import { Box } from 'components/box';
import { Category, StickyMessageInterface } from 'types/types';
import AppDownloadBanner from 'components/app-download-banner';
import { AlgoliaIndexEnum, HeaderDesignEnum } from 'types/interface';
import TopBar from 'components/_global/header/top-bar';
import config from '../../../util/load-config';
import { zIndices } from 'constants/z-indices';
import {
  HEADER_SPACING_HEIGHT,
  HEADER_SPACING_HEIGHT_W_SEARCH,
} from '../../../constants/header';
import StickyMessages from 'components/_global/header/sticky-messages';

const Header = ({
  messages,
  selectedTopTab,
  hideClock,
  showAdoHeader,
  searchIndexName,
  headerTaglineText,
  headerTaglineTitle,
  categories,
  disableHeaderShrinking,
}: {
  messages?: StickyMessageInterface[];
  selectedTopTab: string | null;
  hideClock?: boolean;
  showAdoHeader?: boolean;
  searchIndexName?: AlgoliaIndexEnum;
  headerTaglineTitle?: string;
  headerTaglineText?: string;
  categories?: Category[];
  disableHeaderShrinking?: boolean;
}) => (
  <>
    <Box position="fixed" top={0} zIndex={zIndices.HEADER_BAR} width="100%">
      <AppDownloadBanner />

      <TopBar
        searchIndexName={searchIndexName}
        selectedTopTab={selectedTopTab}
        hideClock={hideClock}
        showAdoHeader={showAdoHeader}
        headerTaglineText={headerTaglineText}
        headerTaglineTitle={headerTaglineTitle}
        categories={categories}
        disableHeaderShrinking={disableHeaderShrinking}
      />
    </Box>

    <Box
      className="spacer"
      height={
        // NOTE: these are hardcoded heights based on design,
        // will need to updated manually if the design height changes
        config.featureFlags.headerDesign === HeaderDesignEnum.Sleek
          ? ['75px', '85px']
          : searchIndexName
          ? HEADER_SPACING_HEIGHT_W_SEARCH
          : HEADER_SPACING_HEIGHT
      }
    />

    <StickyMessages messages={messages} />
  </>
);

export default Header;
